// Design System Constants
export const COLORS = {
  brand: {
    primary: 'var(--brand)',
    hover: 'var(--brand-hover)',
    text: 'var(--brand-text)',
  },
  surface: {
    1: 'var(--surface-1)',
    2: 'var(--surface-2)',
    3: 'var(--surface-3)',
    4: 'var(--surface-4)',
  },
  text: {
    primary: 'var(--text-1)',
    secondary: 'var(--text-2)',
    tertiary: 'var(--text-3)',
  },
  semantic: {
    success: 'var(--success)',
    error: 'var(--error)',
    warning: 'var(--warning)',
  },
} as const;

// Animation Constants
export const ANIMATION = {
  duration: {
    fast: 200,
    normal: 300,
    slow: 500,
  },
  easing: {
    smooth: [0.4, 0.0, 0.2, 1],
    bounce: [0.68, -0.55, 0.265, 1.55],
  },
} as const;

// Spacing Constants
export const SPACING = {
  xs: '0.25rem',
  sm: '0.5rem',
  md: '1rem',
  lg: '1.5rem',
  xl: '2rem',
  '2xl': '3rem',
} as const;

// Navigation Constants
export const NAVIGATION_ITEMS = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'blog', label: 'Blog' },
] as const;

// Local Storage Keys
export const STORAGE_KEYS = {
  searchHistory: 'laptopSearchHistory',
  theme: 'theme',
} as const;

// App Configuration
export const APP_CONFIG = {
  maxHistoryItems: 10,
  searchDelay: 300,
  animationDuration: 300,
} as const;
